import * as TYPES from './types';

export const patientRegistrationDetailsLoadSuccess = (details) => ({
  type: TYPES.PATIENT_REGISTRATION_DETAILS_LOAD_SUCCESS,
  details,
});

export const loadReminderSettings = (reminderSettings) => ({
  type: TYPES.LOAD_REMINDERSETTINGS,
  reminderSettings,
});

export const loadPatientReminderSettings = (patientReminderSettings) => ({
  type: TYPES.LOAD_PATIENT_REMINDERSETTINGS,
  patientReminderSettings,
});

export const setNotificationEmail = (email) => ({
  type: TYPES.SET_NOTIFICATION_EMAIL,
  email,
});

export const updatePatientNotificationFormInput = (inputName, value) => ({
  type: TYPES.UPDATE_NOTIFICATION_FORMINPUT,
  formInput: { inputName, value },
});

export const disableAppointmentSms = () => ({
  type: TYPES.DISABLE_APPOINTMENTSMS,
});
